import { jsxs, jsx } from 'react/jsx-runtime';
import { Avatar as Avatar$1 } from 'primereact/avatar';
import clsx from 'clsx';

function Avatar(_ref) {
  let {
    userName,
    role,
    large,
    showDescription,
    colorsReverted,
    underline
  } = _ref;
  const initials = userName.split(' ').map(name => name.charAt(0)).slice(0, 2).join('');
  const descriptionTemplate = (userName, role) => {
    const userNameClassName = clsx('guardian-avatar--username', underline ? 'guardian-avatar--username--underline' : '');
    const userNameNode = jsx("div", {
      className: userNameClassName,
      children: userName
    });
    if (!role) {
      return userNameNode;
    }
    return jsxs("div", {
      className: "flex flex-column",
      children: [userNameNode, jsx("div", {
        className: "guardian-avatar--role",
        children: role
      })]
    });
  };
  const wrapperClassName = clsx('flex align-items-center gap-2', colorsReverted ? 'guardian-avatar--reverted' : null, large ? 'guardian-avatar--large' : null);
  return jsxs("div", {
    className: wrapperClassName,
    children: [jsx(Avatar$1, {
      className: "guardian-avatar",
      label: initials,
      shape: "circle",
      size: large ? 'large' : 'normal'
    }), (showDescription || role) && descriptionTemplate(userName, role)]
  });
}

export { Avatar };
